import { FC } from "react";
import "./Modal.css";
import WidgetContainer from "../../UiLib/WidgetContainer/WidgetContainer";
import Button from "../../UiLib/Button/Button";
import Cross from "../../../assets/images/cross.svg";
import Error from "../../../assets/errorRed.svg";

interface IModalErrorProps {
    onClose?: () => void;
    hideCross?: boolean;
    hideOk?: boolean;
    bodyText?: string;
    headerText?: string;
}

const ModalError: FC<IModalErrorProps> = ({ onClose, bodyText, headerText, hideCross, hideOk }) => {
    return (
        <WidgetContainer
            style={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                width: "100%",
            }}
            className="modal-container"
        >
            <div className="modal-header">
                <h1>
                    <img src={Error}></img>
                </h1>
                {!hideCross ? <Button callBack={() => (onClose ? onClose() : null)} image={Cross} /> : null}
            </div>
            <div style={{ flex: "1 1" }}>
                <div className="modal-header-text">{headerText}</div>
                <div className="modal-body-text">{bodyText}</div>
            </div>
            <div className="modal-buttons">
                {!hideOk ? (
                    <button className="light-blue-button-blue-text" onClick={onClose}>
                        Ок
                    </button>
                ) : null}
            </div>
        </WidgetContainer>
    );
};

export default ModalError;
